var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard-page-index"}},[(_vm.$store.getters.userIsAdmin)?_c('DashboardAdmin'):(_vm.$store.getters.userIsReseller)?_c('DashboardReseller'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }